import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getRootClasses = ({ disabled }) => {
  const classes = ["flex-auto", "flex", "items-center", "gap-8"];
  classes.push(disabled ? "cursor-not-allowed" : "cursor-pointer");
  return concatClasses(classes);
};
const getSlotClasses = ({ disabled, dsf_size }) => {
  const classes = [];
  classes.push(dsf_size === "small" ? "dsf-text-xs" : "dsf-text-s");
  classes.push(disabled ? "text-neutral-300" : "text-neutral-700");
  return concatClasses(classes);
};
const getInputClasses = () => {
  const classes = [
    "grid",
    "h-16",
    "w-16",
    "appearance-none",
    "place-content-center",
    "rounded-full",
    "border-1",
    "border-neutral-200",
    "bg-neutral-0",
    "outline-none",
    "cursor-pointer",
    // radio circle
    "before:h-8",
    "before:w-8",
    "before:scale-0",
    "before:rounded-full",
    "before:bg-secondary-300",
    "before:transition-transform",
    "before:content-['']",
    // hover
    "hover:bg-neutral-50",
    // focus
    "focus:border-secondary-300",
    "focus-visible:shadow-focus-secondary-sm",
    // checked
    "checked:border-secondary-300",
    "checked:before:scale-100",
    "checked:hover:border-secondary-400",
    "checked:hover:bg-neutral-0",
    "checked:before:hover:bg-secondary-400",
    // disabled
    "disabled:pointer-events-none",
    "disabled:bg-neutral-100",
    "disabled:checked:border-neutral-200",
    "disabled:checked:bg-neutral-0",
    "disabled:checked:before:bg-neutral-200"
  ];
  return concatClasses(classes);
};
export {
  getInputClasses,
  getRootClasses,
  getSlotClasses
};
